The identifier for the `ApplicationQuestionChoice`.
